module.exports = __webpack_public_path__ + "static/media/BeatrizMoreiraHover.df3eaddb.png";